/**
 * Prefix of query parameters owned by the widget itself, as opposed to
 * campaign / attribution parameters that belong to the partner.
 *
 * The bntrk module skips every key with this prefix when it collects query
 * parameters, so anything named `bndl_wgt_*` never reaches an app as
 * attribution data. `bndl_wgt_setup` (the tracking setup payload the widget
 * appends to app URLs) is part of the same family.
 */
export const WIDGET_PARAM_PREFIX = 'bndl_wgt_';

/**
 * Switches of a standalone widget link.
 * See `src/widget/utils/getStandaloneFlags` for how they are read.
 */
export const SINGLE_APP_PARAM = `${WIDGET_PARAM_PREFIX}single_app`;
export const NO_TRACK_PARAM = `${WIDGET_PARAM_PREFIX}notrack`;
